import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { GiFactory, GiChimney, GiPulleyHook } from 'react-icons/gi';
import { RiBuildingLine } from 'react-icons/ri';
import { MdPrecisionManufacturing } from 'react-icons/md';
import { FaTools } from 'react-icons/fa';
import weBuyYourProject from '~/images/we-buy-your-project/we-buy-your-project.png';
import Image from 'next/image';
import CoorpLayout, { Title, Text } from '@/components/layout/CoorpLayout';
import WeBuyYourProjectForm from '@/components/forms/WeBuyYourProjectForm';

export default function WeBuyYourProjectPage() {
  const { t } = useTranslation('products');

  return (
    <CoorpLayout
      headingOne={t('products:BUY_YOUR_PROJECT_TITLE')}
      headingTwo={t('products:BUY_YOUR_PROJECT_HEADING')}
      headingThree={t('products:BUY_YOUR_PROJECT_H3_HERO')}
      breadcrubPages={[
        {
          name: t('products:SERVICES_GINDUMAC_MENU'),
        },
        {
          name: t('products:BUY_YOUR_PROJECT_TITLE'),
          href: '/we-buy-your-project',
        },
      ]}
    >
      <Title title={t('products:BUY_YOUR_PROJECT_HEADING')} />
      <Text text={t('products:BUY_YOUR_PROJECT_P1')} />
      <div className='my-7 flex justify-center md:mt-12'>
        <Image
          src={weBuyYourProject}
          alt={t('products:BUY_YOUR_PROJECT_TITLE')}
        />
      </div>
      <Text text={t('products:BUY_YOUR_PROJECT_P2')} />
      <Text text={t('products:BUY_YOUR_PROJECT_P3')} />
      <WhatWeBuy />
      <WeBuyYourProjectForm />
    </CoorpLayout>
  );
}

function WhatWeBuy() {
  const { t } = useTranslation('products');

  const whatWeBuy = [
    {
      src: GiFactory,
      text: t('products:BUY_YOUR_PROJECT_ICON_TEXT1'),
    },
    {
      src: GiChimney,
      text: t('products:BUY_YOUR_PROJECT_ICON_TEXT2'),
    },
    {
      src: RiBuildingLine,
      text: t('products:BUY_YOUR_PROJECT_ICON_TEXT3'),
    },
    {
      src: MdPrecisionManufacturing,
      text: t('products:BUY_YOUR_PROJECT_ICON_TEXT4'),
    },
    {
      src: FaTools,
      text: t('products:BUY_YOUR_PROJECT_ICON_TEXT5'),
    },
    {
      src: GiPulleyHook,
      text: t('products:BUY_YOUR_PROJECT_ICON_TEXT6'),
    },
  ];

  return (
    <div className='my-4 md:my-12'>
      <div className='grid grid-cols-1 content-center gap-4 md:grid-cols-2 xl:grid-cols-3'>
        {whatWeBuy.map((item, index) => (
          <div
            className={`flex flex-col items-center bg-brand-800 md:flex-row`}
            key={index}
          >
            <div className='m-4 md:m-3'>
              <item.src
                size={70}
                className=' rounded-full bg-brand-500 fill-secondary-500 p-3 xl:mr-4'
              />
            </div>
            <h3 className='mx-7 my-5 text-center text-[1.1em] font-semibold text-white md:mx-0 md:my-0 md:text-left lg:text-[1.4rem]'>
              {item.text}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
}
